import React from 'react';
import { useStore } from '../../context/StoreContext';

export default function MobileBottomNav() {
  const { setCartOpen, showToast, wishlist } = useStore();

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-white/95 glass border-t border-slate-200">
      <div className="grid grid-cols-5 h-[64px]">
        <a className="grid place-items-center text-[11px] font-semibold text-indigo-600">
          <i className="ri-home-5-fill text-xl mb-0.5"></i>Home
        </a>
        <a href="#shop" className="grid place-items-center text-[11px] font-medium text-slate-600">
          <i className="ri-compass-3-line text-xl mb-0.5"></i>Explore
        </a>
        <button className="grid place-items-center">
          <div className="w-12 h-12 rounded-full bg-slate-900 text-white grid place-items-center -mt-4 shadow-lg">
            <i className="ri-flashlight-line text-xl"></i>
          </div>
        </button>
        <button 
          onClick={() => showToast(`Wishlist has ${wishlist.length} items`)}
          className="grid place-items-center text-[11px] font-medium text-slate-600"
        >
          <i className="ri-heart-3-line text-xl mb-0.5"></i>Wishlist
        </button>
        <button 
          onClick={() => setCartOpen(true)}
          className="grid place-items-center text-[11px] font-medium text-slate-600"
        >
          <i className="ri-shopping-bag-3-line text-xl mb-0.5"></i>Bag
        </button>
      </div>
    </div>
  );
}